import request from '@/utils/request'

/**
 * 获取变量列表
 */
export function getVariableList(params) {
  return request({
    url: '/variable/list',
    method: 'get',
    params
  })
}

/**
 * 获取变量详情
 */
export function getVariableDetail(id) {
  return request({
    url: '/variable/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 创建变量
 */
export function createVariable(data) {
  return request({
    url: '/variable/add',
    method: 'post',
    data
  })
}

/**
 * 更新变量
 */
export function updateVariable(data) {
  return request({
    url: '/variable/update',
    method: 'post',
    data
  })
}

/**
 * 删除变量
 */
export function deleteVariable(params) {
  return request({
    url: '/variable/delete',
    method: 'get',
    params
  })
}

/**
 * 批量删除变量
 */
export function deleteVariableBatch(data) {
  return request({
    url: '/variable/delete-batch',
    method: 'post',
    data
  })
}

/**
 * 读取变量值
 */
export function readVariable(data) {
  return request({
    url: '/variable/read',
    method: 'post',
    data
  })
}

/**
 * 写入变量值
 */
export function writeVariable(data) {
  return request({
    url: '/variable/write',
    method: 'post',
    data
  })
}
